import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";
import '@/Pages/Dolyame/scss/index.scss';

class Dolyame extends React.Component {
    state = {
        videoStartFlag: false
    };

    videoStart = () => {
        this.setState({videoStartFlag: true})
    };

    render() {
        const {videoStartFlag} = this.state;
        let {config = {}, stores = {}, mobileApp = false} = this.props;
        const {paymentMethod = {}} = config;
        const {dolyame = {}} = paymentMethod;
        const {max = 0} = dolyame;
        const {catalogStore = {}} = stores;

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className={`container`}>
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <Link className={`breadcrumbs__link`} href={`/`}>
                                    Главная
                                </Link>
                                <p className={`breadcrumbs__text`}>
                                    Покупка долями
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`container`}>
                    <div className={`pageDolyame`}>
                        <div className={`pageDolyame-main`}>
                            <div className={`pageDolyame-main__content`}>
                                <p className={`pageDolyame-main__title`}>
                                    Покупайте Долями в PLATINA
                                </p>
                                <p className={`pageDolyame-main__text`}>
                                    Долями позволяет разделить сумму покупки
                                    до {max.toLocaleString('ru')} рублей
                                    на 4 равных части без комиссий и переплат
                                </p>
                                {!mobileApp && (
                                    <Link href={`/catalog/price-min-0,price-max-30000`}
                                              className={`btn btn__pageDolyamePurchase`}>
                                        Перейти к покупкам
                                    </Link>
                                )}
                            </div>
                            <div className={`pageDolyame-main__banner`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/dolyame/dolyameBanner.webp`}
                                    />
                                    <img className={``}
                                         src={`/storage/img/dolyame/dolyameBanner.png`}
                                         alt={`dolyameBanner`}
                                         title={`dolyameBanner`}
                                         loading={`lazy`}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div className={`pageDolyame-pay`}>
                            <div className={`pageDolyame-pay__item`}>
                                <Svg id={`pageDolyameIcon1`} className={`svg__pageDolyameIcon1`} />
                                <p className={`pageDolyame-pay__title`}>Покупайте сразу все</p>
                                <p className={`pageDolyame-pay__text`}>
                                    Можно не откладывать деньги на то, что давно хотели, и купить уже сейчас
                                </p>
                            </div>
                            <div className={`pageDolyame-pay__item`}>
                                <Svg id={`pageDolyameIcon2`} className={`svg__pageDolyameIcon2`} />
                                <p className={`pageDolyame-pay__title`}>Распределяйте расходы</p>
                                <p className={`pageDolyame-pay__text`}>
                                    Оплачивайте покупки частями — по 25% каждые две недели с зарплаты
                                </p>
                            </div>
                            <div className={`pageDolyame-pay__item`}>
                                <Svg id={`pageDolyameIcon3`} className={`svg__pageDolyameIcon3`} />
                                <p className={`pageDolyame-pay__title`}>Без процентов и комиссий</p>
                                <p className={`pageDolyame-pay__text`}>
                                    Никаких дополнительных платежей — как обычная оплата картой
                                </p>
                            </div>
                        </div>
                        <div className={`pageDolyame-how`}>
                            <p className={`pageDolyame-how__title`}>
                                Как работает оплата Долями в PLATINA
                            </p>
                            <div className={`pageDolyame-how__steps`}>
                                <div className={`pageDolyame-how__step`}>
                                    <div className={`pageDolyame-how__image`}>
                                        <picture>
                                            <source type={`image/webp`}
                                                    srcSet={`/storage/img/dolyame/howIconStep1.webp`}
                                            />
                                            <img className={``}
                                                 src={`/storage/img/dolyame/howIconStep1.jpg`}
                                                 alt={`Step1`}
                                                 title={`Step1`}
                                                 loading={`lazy`}
                                            />
                                        </picture>
                                    </div>
                                    <p className={`pageDolyame-how__subTitle`}>Сформируйте корзину с покупками</p>
                                    <p className={`pageDolyame-how__description`}>И выберите способ оплаты
                                        Долями</p>
                                </div>
                                <div className={`pageDolyame-how__step`}>
                                    <div className={`pageDolyame-how__image`}>
                                        <picture>
                                            <source type={`image/webp`}
                                                    srcSet={`/storage/img/dolyame/howIconStep2.webp`}
                                            />
                                            <img className={``}
                                                 src={`/storage/img/dolyame/howIconStep2.jpg`}
                                                 alt={`Step1`}
                                                 title={`Step1`}
                                                 loading={`lazy`}
                                            />
                                        </picture>
                                    </div>
                                    <p className={`pageDolyame-how__subTitle`}>Укажите свой номер телефона</p>
                                    <p className={`pageDolyame-how__description`}>И привяжите карту для оплаты
                                        покупки</p>
                                </div>
                                <div className={`pageDolyame-how__step`}>
                                    <div className={`pageDolyame-how__image`}>
                                        <picture>
                                            <source type={`image/webp`}
                                                    srcSet={`/storage/img/dolyame/howIconStep3.webp`}
                                            />
                                            <img className={``}
                                                 src={`/storage/img/dolyame/howIconStep3.jpg`}
                                                 alt={`Step1`}
                                                 title={`Step1`}
                                                 loading={`lazy`}
                                            />
                                        </picture>
                                    </div>
                                    <p className={`pageDolyame-how__subTitle`}>Оплатите 25% стоимости покупки</p>
                                    <p className={`pageDolyame-how__description`}>
                                        Оставшиеся 3 части спишутся с карты автоматически с шагом в две недели
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={`pageDolyame-video`}>
                            {!videoStartFlag ?
                                <picture onClick={() => this.videoStart()}>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/dolyame/dolyameVideoPreview.webp`}
                                    />
                                    <img className={``}
                                         src={`/storage/img/dolyame/dolyameVideoPreview.jpg`}
                                         alt={`dolyameVideoPreview`}
                                         title={`dolyameVideoPreview`}
                                         loading={`lazy`}
                                    />
                                </picture>
                                :
                                <iframe width="560"
                                        height="315"
                                        src="https://www.youtube.com/embed/R1bj2nXQ1Kw"
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen>

                                </iframe>
                            }
                        </div>
                        <div className={`pageDolyame-faq`}>
                            <p className={`pageDolyame-faq__title`}>
                                Часто задаваемые вопросы
                            </p>
                            <div className={`pageDolyame-faq__list`}>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Нужна ли регистрация в сервисе
                                        Долями?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Нет, отдельная регистрация не нужна. Сервис зарегистрирует вас автоматически
                                        после
                                        совершения покупки по номеру телефона. Далее по этому номеру вы сможете
                                        войти в
                                        мобильное приложение Долями, чтобы отслеживать следующие платежи.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Как работает сервис?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Сервис работает напрямую с сайтом нашего интернет-магазина — выберите Долями
                                        как
                                        способ оплаты и введите данные карты. Долями разделит оплату на 4 части —
                                        первая
                                        часть спишется сразу, следующие три — через каждые две недели. Перед каждым
                                        платежом
                                        вы получите напоминание от сервиса о дате списания.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Есть ли плата за использование
                                        сервиса?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Нет, сервис Долями не берет процентов или комиссий. Вы заплатите ровно сумму
                                        покупки, разделенную на 4 части.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Это кредит? Проверяет ли сервис
                                        кредитную
                                        историю?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Нет, это не кредит. Долями не проверяет кредитную историю и не заключает
                                        кредитный
                                        договор с покупателем. В Долями нет процентной ставки — вы платите только
                                        сумму
                                        покупки разделенную на 4 части.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Куда переводить деньги в день
                                        платежа?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        В дату оплаты сервис будет автоматически списывать средства с карты, которую
                                        вы
                                        привязали в момент покупки. Вам необходимо только удостовериться, что на
                                        карте
                                        есть
                                        нужная сумма. Вы можете внести ближайший платеж раньше или погасить всю
                                        оставшуюся
                                        сумму через мобильное приложение Долями.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>На сколько дней растянется
                                        оплата?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Вы заплатите всю сумму покупки в течение 6 недель. Будет 4 платежа по 25% от
                                        стоимости — первый сразу, в момент покупки; остальные три части каждые две
                                        недели,
                                        пока не выплатите всю сумму.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Где посмотреть предстоящие
                                        платежи?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        График платежей можно узнать в мобильном приложении или в чате на сайте
                                        Долями.
                                        Чтобы посмотреть в приложении, скачайте Долями на мобильный телефон и
                                        зайдите по
                                        номеру, который указывали во время оформления покупки.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Как оформить возврат?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Чтобы оформить возврат, обратитесь к нам в магазин. Вернуть можно всю
                                        покупку
                                        или ее
                                        часть. Мы уведомим Долями о возврате и сервис осуществит его. Деньги
                                        вернутся на
                                        карту в течение 14 дней. Срок зависит от банка-эмитента и платежной системы.
                                    </p>
                                </div>
                                <div className={`pageDolyame-faq__item`}>
                                    <p className={`pageDolyame-faq__subTitle`}>Какие документы нужны для
                                        оформления?</p>
                                    <p className={`pageDolyame-faq__description`}>
                                        Для покупки Долями не нужны документы — только номер телефона и данные карты
                                        для
                                        оплаты.
                                    </p>
                                </div>
                            </div>
                            <a href={`https://dolyame.ru/shopper/help`}
                               className={`btn btn__pageDolyameHelpMe`}
                               target={`_blank`}>
                                Перейти в раздел помощи
                            </a>
                        </div>
                        <div className={`pageDolyame-apps`}>
                            <div className={`pageDolyame-apps__image`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/dolyame/dolyameAppsBanner.webp`}
                                    />
                                    <img className={``}
                                         src={`/storage/img/dolyame/dolyameBanner.png`}
                                         alt={`dolyameBanner`}
                                         title={`dolyameBanner`}
                                         loading={`lazy`}
                                    />
                                </picture>
                            </div>
                            <p className={`pageDolyame-apps__title`}>Управляйте покупками в приложении «Долями»</p>
                            <p className={`pageDolyame-apps__description`}>
                                Следите за датами платежей, вносите оставшуюся часть в любой момент
                            </p>
                            <div className={`pageDolyame-apps__icons`}>
                                <a href="https://apps.apple.com/ru/app/%D0%B4%D0%BE%D0%BB%D1%8F%D0%BC%D0%B8-%D0%BF%D0%BE%D0%BA%D1%83%D0%BF%D0%BA%D0%B8-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D0%B0/id1553066657"
                                   target="_blank"
                                   className={`pageDolyame-apps__icon`}>
                                    <Svg id={`dolyameAppStore`} className={`svg__dolyameAppStore`} />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=ru.tinkoff.bnpl"
                                   target="_blank"
                                   className={`pageDolyame-apps__icon`}>
                                    <Svg id={`dolyameGooglePlay`} className={`svg__dolyameGooglePlay`} />
                                </a>
                                <a href="https://appgallery.huawei.com/app/C104135333"
                                   target="_blank"
                                   className={`pageDolyame-apps__icon`}>
                                    <Svg id={`dolyameAppGallery`} className={`svg__dolyameAppGallery`} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default useWithStore(Dolyame);


